import React from 'react';

import { Icon } from '../icons';

export const NotificationsIcon: Icon['component'] = ({ color, style, ...props }) => {
  return (
    <svg {...props} viewBox="0 0 32 32" fill="none" style={style}>
      <path
        d="M24 11.2C24 8.93684 23.1571 6.76635 21.6569 5.16604C20.1566 3.56573 18.1217 2.66669 16 2.66669C13.8783 2.66669 11.8434 3.56573 10.3431 5.16604C8.84286 6.76635 8 8.93684 8 11.2C8 21.1556 4 24 4 24H28C28 24 24 21.1556 24 11.2Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3067 28C18.0723 28.4041 17.7358 28.7395 17.331 28.9727C16.9262 29.2059 16.4672 29.3286 16 29.3286C15.5329 29.3286 15.0739 29.2059 14.6691 28.9727C14.2642 28.7395 13.9278 28.4041 13.6934 28"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
